import type { GetStaticProps } from 'next';

import { makeStaticPropsRequest } from '../../modules/page-info';
import { makePage } from '../../modules/page-info/page';
import { makePagePropsProvider } from '../../modules/page-info/page-props-provider';
import type { PageProps } from '../../modules/page-info/types';

export const getStaticProps: GetStaticProps<PageProps> = async ({ preview }) => {
  return makeStaticPropsRequest('/terms', 'No terms page entry found')({ preview });
};

const PageComponent = makePage({ pageTitle: 'Terms and Conditions of Supply' });
const TermsPage = makePagePropsProvider<typeof getStaticProps>(PageComponent);
export default TermsPage;
